import { globalUtils } from '@gat-ship/utils'
import { useNotificationStore } from '../store/store-notification'
import type { NotificationType } from '../types/NotificationType'

export class GatshipNotification {
  public title: string
  public description: string
  public id: string
  public notificationType: NotificationType
  public icon: string | undefined
  private notificationStore: ReturnType<typeof useNotificationStore>

  constructor({
    id,
    title,
    description,
    notificationType,
    icon
  }: {
    id?: string
    title: string
    description: string
    notificationType: NotificationType
    icon?: string
  }) {
    this.notificationStore = useNotificationStore()
    this.id = id ?? globalUtils.functions.uuid()
    this.title = title
    this.description = description
    this.notificationType = notificationType
    this.icon = icon
    this.notificationStore.newNotification(this)
  }
}
